export default {
    data() {
        return {
            saveKey: "categoryMatchingData", // Unique key for localStorage
        };
    },
    methods: {
        saveToLocalStorage(data) {
            try {
                localStorage.setItem(this.saveKey, JSON.stringify(data));
            } catch (error) {
                console.error("Error saving to local storage:", error);
            }
        },
        loadFromLocalStorage() {
            try {
                const savedData = localStorage.getItem(this.saveKey);
                return savedData ? JSON.parse(savedData) : null;
            } catch (error) {
                console.error("Error loading from local storage:", error);
                return null;
            }
        },
        clearLocalStorage() {
            try {
                localStorage.removeItem(this.saveKey);
            } catch (error) {
                console.error("Error clearing local storage:", error);
            }
        },
    },
};